var path = 'app/scripts/modules/core/src/pipeline/config/stages/core/stepLabel.html';
var html = "<span class=\"task-label\">{{ step.name | robotToHuman }}</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/stages/core/stepLabel.html
// module id = 835
// module chunks = 0